/*eslint-disable *//*eslint-disable */
import root from '@/_helpers/roots';
import axios from 'axios';
var $ = window.jQuery = require('jquery');
import{ bus } from '@/main';
import toast from '@/services/toast';
import allCountries from './phoneCodeList.json';
let conferenceInfoApiUrl = root.conferenceInfoApiUrl.link;
export default {
  name: 'user-info-for-conference',
  components: {
  },
  props: [
  ],
  data () {
    return {
      submitted:false,
      first_name:'',
      last_name:'',
      email:'',
      organisation:'',
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      allCountriesList:[],
      accept_txt:false
    }
  },
  computed: {
  },
  mounted () {
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    this.getUserCountry()
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
  },
  methods: {
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    sendUserInfoSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let payload = {
            name: this.first_name + ' ' + this.last_name,
            email: this.email,
            organisation: this.organisation
          }
          axios.post(conferenceInfoApiUrl, payload).then(res => {
            toast.success(res.data.msg);
            this.submitted =  false
            this.closeStoreInfoPopup()
            resolve(res);
          }).catch(err => {
            toast.error(err.data.data.email || err.data.user_msg || err.data.msg);
            this.submitted =  false
            reject(err);
          })
          return;
        }
      })
    },
    closeStoreInfoPopup(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('userInfoStoreBus', false);
    },
  },
}